import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';

export class Help extends Component {
  static propTypes = {
    common: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  render() {
    return (
      <div className="common-help">
        <div className="banner">
          <div className="banner-inner">
            <h1>帮助中心</h1>
            <h2>我们将努力为您提供更好的服务和帮助！</h2>
          </div>
        </div>
        <div className="content">
          <div className="content-item login">
            <h3>1.登录问题</h3>
            <div className="inner">
              <p>可以选择手机号码，或者身份证号码登录，两种方式供选择。</p>
              <img src={require("../../images/help3.png")} alt="" />
            </div>
          </div>
          <div className="content-item findCode">
            <h3>2.密码找回</h3>
            <div className="inner">
              <p><b>第一步：</b>在登录页面，点击“忘记密码”链接，进入找回密码页面；</p>
              <img src={require("../../images/help2.png")} alt="" />
              <p><b>第二步：</b>根据提示，逐步操作，找回密码。</p>
              <img src={require("../../images/help1.png")} alt="" />
            </div>
          </div>
          <div className="content-item buy">
            <h3>3.购买问题</h3>
            <div className="inner">
              <p>请不要一个课程多次重复下单购买（友情提示：购买课程包比购买单个课程更划算哦）；</p>
              <p>购买的课程在 <span onClick={() => {
                this.props.history.push('/center/courseManage/0');
              }}>个人中心-课程管理-我的课程</span> 以及 <span onClick={() => {
                this.props.history.push('/center/myOrder/2');
              }}>个人中心-我的订单-已开通订单</span> 中都可以查看。</p>
              <p>建设银行或支付宝支付如无响应，请注意浏览器窗口拦截提示；</p>
            </div>
          </div>
          <div className="content-item pay">
            <h3>4.支付方式</h3>
            <div className="inner">
              <p>如支付异常，建议根据提示检查并重新尝试操作哦，部分银行设置有支付限额，您可以联系发卡银行核实喔；</p>
              <p>支付不成功可能是系统繁忙或网络故障导致的，还请您看看支付不成功有没有提示，稍后刷新页面根据提示重新尝试一下哦。如支付成功后显示课程未购买请联
系客服处理。</p>
            </div>
          </div>
          <div className="content-item refund">
            <h3>5.退款规则</h3>
            <div className="inner">
              <p>
                录播视频课程：
              </p>
              <p>
                A. 用户购买课程之日起7天内非平台技术原因不予退款。技术原因是指：由于平台技术故障引发的连续超过24小时课程无法正常观看、视频无法正常播放。如用户
  个人网络原因、观看设备故障、用户账号丢失等类原因不属于平台技术故障。
              </p>
              <p>
                B. 用户购买超过7天后一律不予退款。
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    common: state.common,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Help);



// WEBPACK FOOTER //
// ./src/features/common/Help.js